module.exports = __webpack_public_path__ + "static/9M_2023_Financial_Reporting-8058c179d68de595c2b40aea4d5f15f3.pdf";